<template>
  <div class="">
    <v-toolbar flat color="transparent">
      <v-btn icon text @click="$router.push('/')">
        <v-icon> mdi-arrow-left </v-icon>
      </v-btn>
      <v-toolbar-title>
        {{ routeName }}
      </v-toolbar-title>
    </v-toolbar>
    <v-card class="colorDominant">
      <v-card-text class="pa-0">
        <v-progress-linear
          height="3"
          indeterminate
          :active="loading"
        ></v-progress-linear>

        <div class="d-flex justify-end mr-4 mt-4">
          <v-btn
            v-show="document && documentLoaded"
            depressed
            small
            @click="printDocument"
            class="white black--text d-print-none"
          >
            <v-icon left>
              mdi-printer
            </v-icon>
            {{ $t("toPrint") }}
          </v-btn>
        </div>

        <!-- Content Html -->
        <div id="content"></div>

        <!-- Components -->
        <Rules v-if="rules" />
        <ResponsibleGaming v-if="responsibleGaming" />
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Rules from "./rules";
import ResponsibleGaming from "./responsibleGaming";

export default {
  name: "about",
  components: {
    Rules,
    ResponsibleGaming,
  },
  data: () => ({
    content: "",
    rules: false,
    responsibleGaming: false,
    loading: false,
    documentLoaded: false,
    document: false,
  }),
  mounted() {
    this.controller(); // 1. executa "apenas" na montagem ou primeiro acesso;
  },
  watch: {
    $route() {
      setTimeout(() => {
        this.$vuetify.goTo(0);
      }, 100);

      this.documentLoaded = false;
      this.controller(); // 2. executa apenas quando troca-se de rota;
    },
  },

  computed: {
    routeName() {
      const routeNameAsTranslation = [
        "terms",
        "privacy",
        "autoExclude",
        "accountSuspend",
        "appClient",
        "appAgent",
      ];

      if (routeNameAsTranslation.includes(this.$route.name)) {
        return this.$t(this.$route.name);
      }

      if (this.$route.name === "responsibleGamingDoc") {
        return this.$t("responsibleGaming");
      }

      return this.$route.name;
    },
  },

  methods: {
    printDocument() {
      this.$printDocument(document.getElementById("content").innerHTML);
    },
    controller() {
      // reset contents:
      this.rules = false;
      this.responsibleGaming = false;
      document.getElementById("content").innerHTML = "";

      //
      // Tratamentos de acordo com as rotas:
      //

      let hasMadeRequest = false;

      if (this.$route.name === "terms") {
        this.actionPost("/player/online/register/operatorDocument");
        this.document = true;
        hasMadeRequest = true;
      }

      if (this.$route.name === "privacy") {
        this.actionPost("/main/getDocumentDataProtection");
        this.document = true;
        hasMadeRequest = true;
      }

      if (this.$route.query.action === "post" && hasMadeRequest === false) {
        this.actionPost();
        this.document = true;
      }

      if (this.$route.query.component === "rules") {
        this.rules = true;
        this.document = false;
      }

      if (this.$route.query.component === "responsibleGaming") {
        this.responsibleGaming = true;
        this.document = false;
      }

      if (this.$route.query.email) {
        const email = this.$route.query.email;
        const content = `Entre em contato conosco através do email <a href="mailto:${email}?subject=${this.$route.name}">${email}</a>.`;
        this.parseHtml(content);
        this.document = false;
      }

      if (this.$route.name === "appClient") {
        const url = this.$route.query.url;
        const client = this.$domain();
        const content = `Baixe nosso aplicativo através do link: <a href="${url}/${client}/apk/userfinal/app-release-signed.apk">${this.$t(
          "appClient"
        )}</a>.`;
        this.parseHtml(content);
        this.document = false;
      }

      if (this.$route.name === "appAgent") {
        const url = this.$route.query.url;
        const client = this.$domain();
        const content = `Baixe nosso aplicativo através do link: <a href="${url}/${client}_pro.apk">${this.$t(
          "appAgent"
        )}</a>.`;
        this.parseHtml(content);
        this.document = false;
      }
    },

    actionPost(endpoint = null) {
      const finalEndpoint = endpoint || this.$route.query.params;
      (this.loading = true),
        (this.content = ""),
        this.$axios
          .post(finalEndpoint, this.$formdata({ domain: this.$domain() }))
          .then((resp) => {
            var content = resp.data;
            if (typeof content === "string") {
              this.parseHtml(content);
            }
            // Terms of Use and Policy Privacy
            if (typeof content.dados.texto === "string") {
              this.parseHtml(content.dados.texto);
            }

            this.documentLoaded = true;
          })
          .catch((error) => {
            const msg = error.response.data.messages[0];
            const color = "warning";
            this.$store.commit("setNotification", { msg, color });
          })
          .finally(() => (this.loading = false));
    },

    // Converte StringHTML para Html
    parseHtml(string) {
      var newDiv = document.createElement("div");
      newDiv.innerHTML = string;
      document
        .getElementById("content")
        .appendChild(newDiv)
        .setAttribute("class", "pa-4");
    },
  },
};
</script>
